import { DepthLightCustom } from '@repo/go-icons';
import type { GridColumnGroupingModel } from '@repo/go-table';
import { useMemo } from 'react';

import { TableHeader } from '../components/TableHeader/TableHeader';

import { FIELD_TO_GROUP_TITLE_KEY } from './FIELD_TO_GROUP_TITLE_KEY';

export const ALERT_RULE_COLUMN_GROUPS = [
  {
    groupId: 'anomalyTypeGroup',
    children: ['anomalyTypeId', 'anomalySubtypeId'],
  },
  {
    groupId: 'parameterGroup',
    children: ['sourceType', 'sourceOption'],
  },
  {
    groupId: 'holeDepthInterval',
    children: ['holeDepthFrom', 'holeDepthTo'],
  },
  {
    groupId: 'depthInterval',
    children: ['depthFrom', 'depthTo'],
  },
  {
    groupId: 'min',
    children: ['minValue', 'minGoStreamCurveId', 'minPercent'],
  },
  {
    groupId: 'max',
    children: ['maxValue', 'maxGoStreamCurveId', 'maxPercent'],
  },
  {
    groupId: 'diff',
    children: ['diffInterval', 'diffValue'],
  },
] as const;

export const ALERT_RULE_GROUPED_COLUMN_FIELDS = new Set<string>(
  ALERT_RULE_COLUMN_GROUPS.flatMap((group) => group.children),
);

export const useColumnGroups = (depthUnit: 'm' | 'ft') => {
  return useMemo(
    (): GridColumnGroupingModel => [
      {
        groupId: ALERT_RULE_COLUMN_GROUPS[0].groupId,
        children: ALERT_RULE_COLUMN_GROUPS[0].children.map((field) => ({ field })),
        renderHeaderGroup() {
          return <TableHeader field={'anomalyTypeGroup'} textTKey={FIELD_TO_GROUP_TITLE_KEY['anomalyTypeGroup']} />;
        },
      },
      {
        groupId: ALERT_RULE_COLUMN_GROUPS[1].groupId,
        children: ALERT_RULE_COLUMN_GROUPS[1].children.map((field) => ({ field })),
        renderHeaderGroup() {
          return <TableHeader field={'parameterGroup'} textTKey={FIELD_TO_GROUP_TITLE_KEY['parameterGroup']} />;
        },
      },
      {
        groupId: ALERT_RULE_COLUMN_GROUPS[2].groupId,
        children: ALERT_RULE_COLUMN_GROUPS[2].children.map((field) => ({ field })),
        renderHeaderGroup() {
          return (
            <TableHeader
              field={'holeDepthInterval'}
              textTKey={FIELD_TO_GROUP_TITLE_KEY['holeDepthInterval']}
              icon={<DepthLightCustom />}
              unit={depthUnit}
            />
          );
        },
      },
      {
        groupId: ALERT_RULE_COLUMN_GROUPS[3].groupId,
        children: ALERT_RULE_COLUMN_GROUPS[3].children.map((field) => ({ field })),
        renderHeaderGroup() {
          return (
            <TableHeader
              field={'depthInterval'}
              textTKey={FIELD_TO_GROUP_TITLE_KEY['depthInterval']}
              icon={<DepthLightCustom />}
              unit={depthUnit}
            />
          );
        },
      },
      {
        groupId: ALERT_RULE_COLUMN_GROUPS[4].groupId,
        children: ALERT_RULE_COLUMN_GROUPS[4].children.map((field) => ({ field })),
        renderHeaderGroup() {
          return <TableHeader field={'min'} textTKey={FIELD_TO_GROUP_TITLE_KEY['min']} />;
        },
      },
      {
        groupId: ALERT_RULE_COLUMN_GROUPS[5].groupId,
        children: ALERT_RULE_COLUMN_GROUPS[5].children.map((field) => ({ field })),
        renderHeaderGroup() {
          return <TableHeader field={'max'} textTKey={FIELD_TO_GROUP_TITLE_KEY['max']} />;
        },
      },
      {
        groupId: ALERT_RULE_COLUMN_GROUPS[6].groupId,
        children: ALERT_RULE_COLUMN_GROUPS[6].children.map((field) => ({ field })),
        renderHeaderGroup() {
          return <TableHeader field={'diff'} textTKey={FIELD_TO_GROUP_TITLE_KEY['diff']} />;
        },
      },
    ],
    [depthUnit],
  );
};
